import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import { useLocation } from 'react-router-dom';
import gql from 'graphql-tag';
import { AccountContext } from '../../components/AccountContext';
import ExecutiveReportList from './ExecutiveReportList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query ExecutiveReports(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: ExecutiveReportFilter
    $sort: ExecutiveReportSortSpecifier
  ) {
    account(id: $accountId) {
      id
      executiveReports(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            teamName
            numberOfSurveys
            createdOn
            updatedOn
            template {
              id
              title
            }
          }
        }
      }
    }
  }
`;

const ExecutiveReportListContainer = () => {
  const currentAccount = useContext(AccountContext);
  const location = useLocation();
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };

  return (
    <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
      {({ data, loading, error }) => {
        if (error) return `Error! ${error.message}`;

        const connection = data && data.account ? data.account.executiveReports : emptyConnection();

        return <ExecutiveReportList connection={connection} loading={loading} />;
      }}
    </Query>
  );
};

export default ExecutiveReportListContainer;
